import React from 'react'

function LIstDetailCard ({ listData }) {
  return (
    <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 mt-2 border bg-gray-100 border-gray-100 p-2 rounded pt-4'>
      {listData?.map((data, index) => (
        <div className='mb-4' key={index}>
          <h5 className='text-14-gray mb-1'>{data?.label}</h5>
          <h4 className='text-16-gray !font-semibold'>{data?.value}</h4>
        </div>
      ))}
    </div>
  )
}

export default LIstDetailCard
